import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { Account } from 'app/modules/main/models/account';
import { Authorization } from 'app/modules/main/models/authorization';
import { UserSettings } from 'app/modules/main/models/user-settings';
import { AncillaryEndpointsService } from 'app/modules/main/services/ancillary-endpoints.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const GATEKEEPER_FEATURES = new InjectionToken<number>('GATEKEEPER_FEATURES');

interface GatekeeperResponse {

  resultSet: {

    feature: string;
    enabled: boolean;

  }[],

}

@Injectable({ providedIn: 'root' })
export class UserFeatureFlagsFetcher {

  constructor(
    private readonly http: HttpClient,
    private readonly serviceEndpoints: AncillaryEndpointsService,
    @Inject(GATEKEEPER_FEATURES) private readonly gatekeeperFeatures: string[],
  ) {
  }

  public fetch(
    authorization: Authorization<Account>
  ): Observable<UserSettings> {

    const options = {
      params: {
        accountType: authorization.account.accountType.toLowerCase(),
        linkedAccountId: authorization.account.accountId.toString(),
        userUuid: authorization.userId,
        features: this.gatekeeperFeatures.join(','),
      },
    };

    return this.http.get<GatekeeperResponse>(this.serviceEndpoints.gatekeeperUrl, options)
      .pipe(map(response => ({ featureFlags: response.resultSet })));
  }

}
